import request from '@/utils/request';

// 获取热门城市
export function getHotCity(){
  return request({
    url:'/basic/app/api/pcasInfo/hotCity',
    method:'GET'
  })
}

// 获取地级城市
export function getCityList(){
  return request({
    url:'/basic/app/api/pcasInfo/cityPanel',
    method:'GET'
  })
}